import { useMutation } from 'react-query'
import postCurrent from '../services/postCurrent'

function usePostCurrent() {

  return useMutation(()=>postCurrent() );
}

export default usePostCurrent
